import { render } from "./UKFlag.vue?vue&type=template&id=21430e6e"
import script from "./UKFlag.vue?vue&type=script&lang=js"
export * from "./UKFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__